import { createContext, useContext } from "react";
import { POCreditMemoDetails } from "../types/POCreditMemoDetails";
import { POCreditMemoContextType } from "../types/POCreditMemoContextType";


const POCreditMemoContext = createContext<{
	creditMemo: POCreditMemoContextType,
	modify: (creditMemo: POCreditMemoDetails) => void
}>
	({
		creditMemo: {} as POCreditMemoContextType,
		modify: () => { }
	});

const usePOCreditMemo = () => useContext(POCreditMemoContext);

export { POCreditMemoContext, usePOCreditMemo }
